import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import {
  PrismicUtils,
  TenantName,
} from '@segurosvoluntarios_vel/commons-services';
import { FormPago } from 'src/app/pago/enums/FormPago.enum';
import { ContenidoDePagos } from 'src/app/pago/models/ContenidoDePagos.model';
import { TarjetaDeCreditoFormValidators } from 'src/app/pago/validators/tarjeta-de-credito-form.validator';
import { ManagerTarjetaDeCreditoService } from 'src/app/pago/services/manager-credit/manager-credit-card.service';

@Component({
  selector: 'app-form-datos-tarjeta-de-credito',
  templateUrl: './form-datos-tarjeta-de-credito.component.html',
  styleUrls: ['./form-datos-tarjeta-de-credito.component.scss'],
  providers: [ManagerTarjetaDeCreditoService],
})
export class FormDatosTarjetaDeCreditoComponent {
  static readonly DEFAULT_MIN_LENGTH_CODIGO_DE_SEGURIDAD = 3;
  readonly MONTHS = ManagerTarjetaDeCreditoService.MONTHS;
  readonly CANTIDAD_DE_CUOTAS =
    ManagerTarjetaDeCreditoService.CANTIDAD_DE_CUOTAS;
  readonly YEARS = ManagerTarjetaDeCreditoService.YEARS;
  readonly SURA_TENANT = TenantName.SURA;
  maxLengthCodigoDeSeguridad: number =
    FormDatosTarjetaDeCreditoComponent.DEFAULT_MIN_LENGTH_CODIGO_DE_SEGURIDAD;

  @Input() tarjetaDeCreditoFormGroup: FormGroup;
  @Input() submitted: boolean;
  @Input() totalAPagar: number;
  @Input() contenido: ContenidoDePagos;
  @Output() activarRenovacionAutomaticaChange: EventEmitter<
    boolean
  > = new EventEmitter<boolean>();

  constructor(public prismicUtil: PrismicUtils) {}

  get controlNumeroTarjeta(): AbstractControl {
    return this.tarjetaDeCreditoFormGroup.get(FormPago.NUMERO_DE_TARJETA);
  }

  get controlCodigoDeSeguridad(): AbstractControl {
    return this.tarjetaDeCreditoFormGroup.get(FormPago.CODIGO_DE_SEGURIDAD);
  }

  get controlExpirationMonth(): AbstractControl {
    return this.tarjetaDeCreditoFormGroup.get(FormPago.EXPIRATION_MONTH);
  }

  get controlExpirationYear(): AbstractControl {
    return this.tarjetaDeCreditoFormGroup.get(FormPago.EXPIRATION_YEAR);
  }

  get controlCantidadDeCuotas(): AbstractControl {
    return this.tarjetaDeCreditoFormGroup.get(FormPago.CANTIDAD_DE_CUOTAS);
  }

  get controlHabilitarRenovacionAutomatica(): AbstractControl {
    return this.tarjetaDeCreditoFormGroup.get(
      FormPago.HABILITAR_RENOVACION_AUTOMATICA
    );
  }

  activarRenovacionAutomatica(activarRenovacionAutomatica: boolean) {
    this.activarRenovacionAutomaticaChange.emit(activarRenovacionAutomatica);
  }

  handleChangeNumeroTarjetaDeCredito(numeroTarjetaDeCredito: string) {
    if (numeroTarjetaDeCredito) {
      this.setMaxLengthCodigoDeSeguridad(numeroTarjetaDeCredito);
      this.setValidatorCodigoDeSeguridad(numeroTarjetaDeCredito);
      this.controlCodigoDeSeguridad.updateValueAndValidity();
    }
  }

  setMaxLengthCodigoDeSeguridad(numeroTarjetaDeCredito: string) {
    const tipoDeTarjeta = ManagerTarjetaDeCreditoService.findTipoDeTarjeta(
      numeroTarjetaDeCredito
    );
    this.maxLengthCodigoDeSeguridad = tipoDeTarjeta
      ? tipoDeTarjeta.validCvv
      : FormDatosTarjetaDeCreditoComponent.DEFAULT_MIN_LENGTH_CODIGO_DE_SEGURIDAD;
  }

  setValidatorCodigoDeSeguridad(numeroTarjetaDeCredito: string) {
    this.controlCodigoDeSeguridad.setValidators([
      Validators.required,
      TarjetaDeCreditoFormValidators.codigoDeSeguridad(numeroTarjetaDeCredito),
    ]);
  }
}
